import { render } from "./AppFooter.vue?vue&type=template&id=96ec17fe&ts=true"
import script from "./AppFooter.ts?vue&type=script&lang=ts&external"
export * from "./AppFooter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__